(() => {
  const SELECTOR = '[data-community-favorites-carousel]';
  const AXIS_THRESHOLD = 8;
  const DRAG_THRESHOLD = 4;

  function bindCarousel(carousel) {
    if (!(carousel instanceof HTMLElement)) return;
    if (carousel.dataset.communityFavoritesDrag === 'true') return;
    carousel.dataset.communityFavoritesDrag = 'true';

    let suppressNextClick = false;

    carousel.addEventListener(
      'click',
      (event) => {
        if (!suppressNextClick) return;
        suppressNextClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    carousel.addEventListener(
      'wheel',
      (event) => {
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;

        const root = document.scrollingElement || document.documentElement;
        if (!root || root.scrollHeight <= root.clientHeight) return;

        event.preventDefault();
        root.scrollTop += event.deltaY;
      },
      { passive: false }
    );

    carousel.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (carousel.scrollWidth <= carousel.clientWidth) return;

      const pointerId = event.pointerId;
      const startX = event.clientX;
      const startY = event.clientY;
      const startScrollLeft = carousel.scrollLeft;
      let axisDecided = false;
      let horizontalActive = false;
      let didDrag = false;

      const detach = () => {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
        carousel.classList.remove('is-dragging');
      };

      const onMove = (ev) => {
        if (ev.pointerId !== pointerId) return;

        if (!axisDecided) {
          const adx = Math.abs(ev.clientX - startX);
          const ady = Math.abs(ev.clientY - startY);
          if (adx < AXIS_THRESHOLD && ady < AXIS_THRESHOLD) return;
          axisDecided = true;
          if (ady >= adx) {
            detach();
            return;
          }
          horizontalActive = true;
          carousel.classList.add('is-dragging');
        }

        if (!horizontalActive) return;

        if (ev.pointerType !== 'mouse') {
          ev.preventDefault();
        }

        const dx = ev.clientX - startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) {
          didDrag = true;
        }
        carousel.scrollLeft = startScrollLeft - dx;
      };

      const onUp = (ev) => {
        if (ev.pointerId !== pointerId) return;
        detach();
        if (didDrag) {
          suppressNextClick = true;
        }
      };

      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    });
  }

  function initAll(root) {
    const scope = root instanceof Document || root instanceof HTMLElement ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(bindCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!(section instanceof HTMLElement)) return;
    initAll(section);
  });
})();
